import { z } from "zod";
import { apiErrorSchema } from "./schemas";

const apiBaseUrl = process.env.NODE_ENV === 'production'
  ? 'https://api.padlo.co'
  : 'http://localhost:3000';

interface ApiResponse<T> {
  data: T;
  headers: Headers;
}

export async function apiFetch<T>(
  endpoint: string,
  options: RequestInit = {},
  schema?: z.ZodType<T>
): Promise<ApiResponse<T>> {
  const token = localStorage.getItem("jwt");
  const headers = new Headers(options.headers || {});

  if (token) {
    headers.set("Authorization", `Bearer ${token}`);
  }

  // Ensure we have the basic headers for JSON API
  if (!headers.has("Accept")) {
    headers.set("Accept", "application/json");
  }

  if (options.body && !headers.has("Content-Type")) {
    headers.set("Content-Type", "application/json");
  }

  const response = await fetch(`${apiBaseUrl}${endpoint}`, {
    ...options,
    headers,
  });

  if (options.method === 'DELETE') {
    return { data: { success: true } as T, headers: response.headers };
  }

  const data = await response.json();

  if (!response.ok) {
    // Validate error response
    const validatedError = apiErrorSchema.safeParse(data);
    if (validatedError.success) {
      throw new Error(validatedError.data.message);
    }
    throw new Error(response.statusText);
  }

  // Validate response data if schema is provided
  if (schema) {
    const validated = schema.safeParse(data);
    if (!validated.success) {
      console.error('API Response validation failed:', validated.error);
      console.error('API Response XXX:', data);
      throw new Error('Invalid API response format');
    }
    return { data: validated.data, headers: response.headers };
  }

  return { data, headers: response.headers };
}
